import * as Sentry from "@sentry/react";

export const __sentryInit = () => {
  Sentry.init({
    dsn: "https://d471fc12b1f7f9583e74bf5bf9752b37@o4508620924518400.ingest.de.sentry.io/4508623764979792",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/lp\.p2p\.me/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.VITE_ENVIRONMENT
  });
};

export const __setUser = (address: string) => {
  Sentry.setUser({ username: address });
};
